import multiselect from './multiselect.vue';
import { withMeta } from '@/helpers/dataLayer';

export default {
  components: {
    multiselect,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    required: Boolean,
    placeholder: String,
    label: {
      type: String,
      required: true,
    },
    trackBy: {
      type: String,
      required: true,
    },
    value: [String, Object],
    small: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    maxHeight: {
      type: Number,
      default: 200,
    },
    customLabel: {
      type: Function,
    },
    searchable: {
      type: Boolean,
      default: true,
    },
    showNoResults: {
      type: Boolean,
      default: false,
    },
    tabindex: Number,
    gtm: {
      type: String,
      default: '',
    },
    adjust: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    selectModifiers() {
      return {
        'select--has-value': this.value,
        'select--small': this.small,
      };
    },
    gtmObject() {
      const [category, label] = this.gtm.split(',');
      return {
        event: 'eventTrackerTrigger',
        category,
        action: 'select',
        label,
      };
    },
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e);
      if (this.gtm && this.value) {
        this.$gtm.trackEvent(withMeta(this.gtmObject));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/forms/select/select.js